import React from "react";
import PropTypes from "prop-types";
import { formatPhoneNumber } from "../../../shared/helpers/formUtils";

const InfoCards = ({ t, vehicle, customer }) => {
  return (
    <div className="row">
      <div className="col-md-6">
        <div className="card mb-2 info-card vehicle-card">
          <div className="card-header">
            <h3 className="card-title">{t("vehicle")}</h3>
          </div>
          <div className="card-body">
            <ul>
              <li className="mb-1">
                <strong>
                  {vehicle
                    ? `${vehicle.year} ${vehicle.makeName} ${vehicle.modelName}`
                    : "-"}
                </strong>
              </li>
              <li className="mb-1">
                {t("vin")} :{" "}
                {vehicle && vehicle.vin
                  ? vehicle.vin
                  : t("no_vin_available")}
              </li>
              <li>
                {t("vehicle_id")}: {vehicle ? vehicle.modelId : "-"}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className="card mb-2 info-card">
          <div className="card-header">
            <h3 className="card-title">{t("customer")}</h3>
          </div>
          <div className="card-body">
            <ul className="list-unstyled">
              <li className="d-flex gap-3 mb-1">
                <img src="/assets/images/icons/outlined-user.svg" alt="user" />
                <strong>{customer ? customer.fullName : "-"}</strong>
              </li>
              <li className="d-flex gap-3 mb-1">
                <img src="/assets/images/icons/outlined-call.svg" alt="phone" />
                {customer ? formatPhoneNumber(customer.phoneNumber) : "-"}
              </li>
              <li className="d-flex gap-3">
                <img src="/assets/images/icons/outlined-mail.svg" alt="email" />
                {customer ? customer.email || "-" : "-"}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

InfoCards.propTypes = {
  t: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
  customer: PropTypes.object,
};

export default InfoCards;
